import { IDataHelmet } from "./interface";

export const dataHelmet: IDataHelmet =
{
    index: {
        title: "Bom Dia Rural - O Programa de quem planta e produz.",
        desc: "O Programa é exibido na Rede Massa, afiliada ao SBT. Todo Sábado, às 9h."
    },
    materias: {
        title: "Matérias",
        desc: "Reportagens jornalísticas que contam histórias, relatam experiências da vida rural, tendências do mercado, além das inovações tecnológicas aplicadas ao campo."        
    },
    patrocinadores: {
        title: "Patrocinadores",
        desc: "Profissionais dedicados e comprometidos com o crescimento. Especialistas em suas áreas, fundamentais para o Bom Dia Rural."        
    },
    equipe: {
        title: "Equipe",
        desc: "Contamos com nosso time de profissionais altamente qualificados e com experiência no jornalismo há mais de 10 anos."
    },
    sobre: {
        title: "Sobre",
        desc: "Saiba mais sobre o programa que tem mais de 2 milhões de telespectadores e mais de 30 mil seguidores nas redes sociais."
    }
}
